import React from "react";
import { Row } from "@tanstack/react-table";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { StyledRow } from "../../table.styles";
import { ITableProps } from "../../table.types";
import TableRowCells from "./tableRowCells";

function TableBody<T>({
    rows,
    onRowClick,
    rowUniqueKey,
    pageSize,
    rowClassName,
    columnClassName,
    rowHeight,
}: { rows: Row<T>[]; pageSize: number } & Pick<
    ITableProps<T>,
    | "onRowClick"
    | "rowClassName"
    | "rowUniqueKey"
    | "columnClassName"
    | "rowHeight"
>) {
    const token = useEnigmaToken();
    return (
        <tbody>
            {rows.map((row, index, ogRows) => {
                // last row but with partial data
                const isPseudoLastRow =
                    ogRows.length - 1 === index && ogRows.length < pageSize;
                return (
                    <StyledRow
                        token={token}
                        isInteractiveRow={!!onRowClick}
                        isPseudoLastRow={isPseudoLastRow}
                        onClick={() => onRowClick?.(row?.original, index)}
                        className={rowClassName}
                        key={row?.original?.[rowUniqueKey] ?? row.id}
                        isRowSelected={row.getIsSelected()}
                    >
                        <TableRowCells<T>
                            columnClassName={columnClassName}
                            row={row}
                            rowHeight={rowHeight}
                        />
                    </StyledRow>
                );
            })}
        </tbody>
    );
}

export default TableBody;
